import { render, staticRenderFns } from "./MultiEventoButton.vue?vue&type=template&id=87748500&"
import script from "./MultiEventoButton.vue?vue&type=script&lang=js&"
export * from "./MultiEventoButton.vue?vue&type=script&lang=js&"
import style0 from "./MultiEventoButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports